export var applyCypressAttribute = function (cyAttribute, specific) {
    return cyAttribute
        ? {
            cy: cyAttribute.concat(specific ? "-" + specific : ''),
        }
        : undefined;
};
//# sourceMappingURL=cypress.js.map